import {inject} from "@angular/core";
import {ActivatedRouteSnapshot, ResolveFn, RouterStateSnapshot} from "@angular/router";
import {Observable} from "rxjs";
import {LiveResultsService} from "@services";
import {EventItem} from "@model";

export const LiveEventsResolver: ResolveFn<Observable<EventItem[]> |
  Promise<EventItem> | EventItem[]> =
  (route: ActivatedRouteSnapshot,
   state: RouterStateSnapshot,
   liveResultsService: LiveResultsService = inject(LiveResultsService)): Observable<EventItem[]> => {
    return liveResultsService.fetchLiveEvents();
  }
